module.exports = __webpack_public_path__ + "media/src/images/abouts/items/online/dazn_1-dfab500eeb7c8ba3a625d07dcfdabd8f.jpg";